
import loadComponents from 'gia/loadComponents';

import Slider from './slider'
import Contact from './contact'
import Animation from './animation'


class App {

  constructor($) {
    this.create()
  }

  create() {

    //  lazySizes.init()

      const components = {

        Slider: Slider, 
        Contact: Contact,
        Animation: Animation

    
       
      }

      loadComponents(components)

      $('body').addClass('loaded')

  

  }
}

module.exports = App
